import { render, staticRenderFns } from "./initLiveChatMessage.vue?vue&type=template&id=5aa39d4e&scoped=true"
import script from "./initLiveChatMessage.vue?vue&type=script&lang=js"
export * from "./initLiveChatMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa39d4e",
  null
  
)

export default component.exports